import React from 'react';
import {animated} from 'react-spring';
import {Slide} from 'react-awesome-reveal';

export default function Animation() {

   return (
    <div className="description">
    <Slide cascade direction="left">
    <animated.div className="script-bf-box" style={{ transform:  {from:0 , duration:4000} }}>
    <div className="react"></div>
    </animated.div>
    <animated.div className="script-bf-box" style={{ transform: {from:0 , duration:4000} }}>
    <div className="node"></div>
    </animated.div>
    <animated.div className="script-bf-box" style={{ transform: {from:0 , duration:4000} }}>
    <div className="vue"></div>
    </animated.div>
    <animated.div className="script-bf-box" style={{ transform: {from:0 , duration:4000}}}>
    <div className="mongo"></div>
    </animated.div>
    </Slide>
    </div>
  );
}
